import { useQuery } from '@tanstack/react-query';
import { DEPRECATED_QUERY_KEYS } from '@src/query';
import { getLocalizedWidget } from './api';

/**
 * Get and cache a widget
 * @param id Widget id
 */
export const useQueryWidgetLocalized = (id: string) => useQuery({ queryKey: [DEPRECATED_QUERY_KEYS.WIDGET_LOCALIZED, id], queryFn: () => getLocalizedWidget(id) });
